import {
  createRouter,
  createWebHistory,
  createWebHashHistory
} from 'vue-router'
import layout from '@/layout'
import store from '@/store'

/**
 * 私有路由表
 */
export const privateRoutes = [
  {
    path: '/',
    component: layout,
    redirect: '/profile',
    meta: {
      title: '工作台',
      icon: 'dashboard'
    },
    children: [
      {
        path: '/profile',
        name: 'profile',
        component: () =>
          import(/* webpackChunkName: "profile" */ '@/views/profile/index'),
        meta: {
          title: '最近数据',
          icon: 'dashboard'
        }
      }
    ]
  },
  {
    path: '/user',
    component: layout,
    meta: {
      title: '用户管理',
      icon: 'user'
    },
    children: [
      {
        path: '/user/manage',
        name: 'user-manage',
        component: () =>
          import(
            /* webpackChunkName: "user-manage" */ '@/views/user-manage/index'
          ),
        meta: {
          title: '用户数据',
          icon: 'user'
        }
      },
      {
        path: '/user/detail',
        name: 'user-detail',
        component: () =>
          import(
            /* webpackChunkName: "user-detail" */ '@/views/user-detail/index'
          ),
        meta: {
          activeMenu: '/user/manage'
        }
      }
    ]
  },
  {
    path: '/services',
    component: layout,
    meta: {
      title: '服务管理',
      icon: 'chart'
    },
    children: [
      {
        path: '/user/services',
        name: 'user-services',
        component: () =>
          import(
            /* webpackChunkName: "user-detail" */ '@/views/user-services/index'
          ),
        meta: {
          title: '服务进行中',
          icon: 'chart'
        }
      }
    ]
  },
  {
    path: '/trade',
    component: layout,
    meta: {
      title: '交易管理',
      icon: 'reward'
    },
    children: [
      {
        path: '/trade/income',
        name: 'income-overview',
        component: () =>
          import(
            /* webpackChunkName: "income-overview" */ '@/views/income-overview/index'
          ),
        meta: {
          title: '总收入',
          icon: 'reward'
        }
      },
      {
        path: '/user/payments',
        name: 'user-payment',
        component: () =>
          import(
            /* webpackChunkName: "user-payment" */ '@/views/user-payment/index'
          ),
        meta: {
          title: '支付记录',
          icon: 'reward'
        }
      },
      {
        path: '/user/resume-optimize-payments',
        name: 'resume-optimize-payment',
        component: () =>
          import(
            /* webpackChunkName: "resume-optimize-payment" */ '@/views/resume-optimize-payment/index'
          ),
        meta: {
          title: '简历优化充值',
          icon: 'reward'
        }
      },
      {
        path: '/user/wwcoin-exchange',
        name: 'user-wwcoin-exchange',
        component: () =>
          import(
            /* webpackChunkName: "user-wwcoin-exchange" */ '@/views/user-wwcoin-exchange/index'
          ),
        meta: {
          title: '旺旺币兑换',
          icon: 'reward'
        }
      }
    ]
  },
  {
    path: '/resume',
    component: layout,
    meta: {
      title: '简历管理',
      icon: 'article'
    },
    children: [
      {
        path: '/resume/manage',
        name: 'resume-manage',
        component: () =>
          import(
            /* webpackChunkName: "resume-manage" */ '@/views/resume-manage/index'
          ),
        meta: {
          title: '简历数据',
          icon: 'article'
        }
      },
      {
        path: '/resume/editor-usage',
        name: 'editor-usage',
        component: () => import(/* webpackChunkName: "editor-usage" */ '@/views/editor-usage/index'),
        meta: { title: '工作台使用', icon: 'chart' }
      },
      {
        path: '/resume/sharing-growth',
        name: 'sharing-growth',
        component: () => import(/* webpackChunkName: "sharing-growth" */ '@/views/sharing-growth/index'),
        meta: { title: '分享增长', icon: 'chart' }
      },
      {
        path: '/resume-detail',
        name: 'resume-detail',
        component: () =>
          import(
            /* webpackChunkName: "resume-detail" */ '@/views/resume-detail/index'
          ),
        meta: {
          activeMenu: '/resume/manage'
        }
      }
    ]
  },
  {
    path: '/operation',
    component: layout,
    meta: {
      title: '运营配置',
      icon: 'link'
    },
    children: [
      {
        path: '/ad-banner/config',
        name: 'ad-banner-config',
        component: () =>
          import(
            /* webpackChunkName: "ad-banner-config" */ '@/views/ad-banner-config/index'
          ),
        meta: {
          title: '广告栏配置',
          icon: 'link'
        }
      }
    ]
  }
]

/**
 * 公开路由表
 */
export const publicRoutes = [
  {
    path: '/login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/login/index')
  }
]

/**
 * 初始化路由表
 */
export function resetRouter() {
  if (
    store.getters.userInfo &&
    store.getters.userInfo.permission &&
    store.getters.userInfo.permission.menus
  ) {
    const menus = store.getters.userInfo.permission.menus
    menus.forEach((menu) => {
      router.removeRoute(menu)
    })
  }
}

const router = createRouter({
  history:
    process.env.NODE_ENV === 'production'
      ? createWebHistory()
      : createWebHashHistory(),
  routes: [...publicRoutes, ...privateRoutes]
})

export default router
